// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
  background-color: #f8f9fa; /* Un gri foarte deschis pentru contrast */
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.hero-section {
  width: 100%;
  padding: 20px;
  max-width: 80%;
  margin: 0 auto;
}

.hero-image-container {
  position: relative;
  width: 100%;
  height: 100%; /* Înălțime fixă pe desktop */
  overflow: hidden;
  border-radius: 25px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
}

.news-banner {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Asigură că imaginea umple spațiul fără a se deforma */
  display: block;
}

.advanced-search-divider {
  text-align: center;
  margin: 40px 0;
  position: relative;
}

.advanced-search-divider::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background: #ddd;
  z-index: 1;
}

.advanced-search-divider span {
  position: relative;
  z-index: 2;
  background: #f8f9fa;
  padding: 0 20px;
  color: #888;
  font-weight: bold;
  font-size: 0.8rem;
  letter-spacing: 2px;
}

.content-wrapper {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 0px 0px 0px;
  /* padding: 0 20px 60px 20px; */
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .hero-image-container {
    height: 100%;
    border-radius: 15px;
  }
  
  .hero-section {
    padding: 10px;
  }
}
/* MOBILE */
@media (max-width: 480px) {
  .hero-section {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
}
.news-banner {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Asigură că imaginea umple spațiul fără a se deforma */
  display: block;
}
}
.promovate-section {
  max-width: 1100px;
  margin: 40px auto;
  padding: 0 20px;
}

.promovate-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 24px;
}

.promovate-header h2 {
  font-size: 24px;
  font-weight: 800;
  color: #1a1a1a;
}

.promovate-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.promovat-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.promovat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
}

.promovat-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #f4b400;
  color: #1a1a1a;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 2;
}

.promovat-imagine {
  position: relative;
}

.promovat-imagine img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.promovat-no-img {
  width: 100%;
  height: 200px;
  background: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
}

.promovat-poza-count {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0,0,0,0.6);
  color: white;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.promovat-info {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.promovat-titlu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.promovat-titlu strong { font-size: 15px; }

.tip-badge {
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 20px;
  font-weight: 600;
}
.tip-badge.gasit { background: #dcfce7; color: #16a34a; }
.tip-badge.pierdut { background: #fee2e2; color: #dc2626; }

.promovat-detalii {
  display: flex;
  gap: 10px;
  font-size: 13px;
  color: #666;
  flex-wrap: wrap;
  align-items: center;
}

.promovat-contact {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 4px;
}

.promovat-contact a {
  font-size: 15px;
  color: #000000;
  text-decoration: none;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}
.promovat-contact a:hover { opacity: 0.8; }

/* Modal — refolosește clasele din AnimaleGasite.css */
/* Dacă nu ai importul, adaugă aici: */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  animation: fadeIn 0.2s ease;
}

.modal-anunt {
  background: white;
  border-radius: 20px;
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  position: relative;
  animation: slideUp 0.25s ease;
}

/* Mobile */
@media (max-width: 768px) {
  .promovate-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  .promovat-imagine img { height: 150px; }
  .promovate-header h2 { font-size: 20px; }
}

@media (max-width: 480px) {
  .promovate-grid {
    grid-template-columns: 1fr;
  }
  .modal-anunt {
    grid-template-columns: 1fr;
  }
}

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes slideUp {
  from { transform: translateY(30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}`, "",{"version":3,"sources":["webpack://./src/pages/Acasa.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB,EAAE,0CAA0C;EACrE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAE,6BAA6B;EAC3C,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,wDAAwD;EAC3E,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;AACA,WAAW;AACX;EACE;EACA,WAAW;EACX,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,wDAAwD;EAC3E,cAAc;AAChB;AACA;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA,yBAAyB,eAAe,EAAE;;AAE1C;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,4BAA4B,YAAY,EAAE;;AAE1C,sDAAsD;AACtD,sCAAsC;AACtC;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;EACA,wBAAwB,aAAa,EAAE;EACvC,uBAAuB,eAAe,EAAE;AAC1C;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAC5D;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C","sourcesContent":[".home-container {\n  background-color: #f8f9fa; /* Un gri foarte deschis pentru contrast */\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.hero-section {\n  width: 100%;\n  padding: 20px;\n  max-width: 80%;\n  margin: 0 auto;\n}\n\n.hero-image-container {\n  position: relative;\n  width: 100%;\n  height: 100%; /* Înălțime fixă pe desktop */\n  overflow: hidden;\n  border-radius: 25px;\n  box-shadow: 0 20px 40px rgba(0,0,0,0.1);\n}\n\n.news-banner {\n  width: 100%;\n  height: 100%;\n  object-fit: cover; /* Asigură că imaginea umple spațiul fără a se deforma */\n  display: block;\n}\n\n.advanced-search-divider {\n  text-align: center;\n  margin: 40px 0;\n  position: relative;\n}\n\n.advanced-search-divider::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background: #ddd;\n  z-index: 1;\n}\n\n.advanced-search-divider span {\n  position: relative;\n  z-index: 2;\n  background: #f8f9fa;\n  padding: 0 20px;\n  color: #888;\n  font-weight: bold;\n  font-size: 0.8rem;\n  letter-spacing: 2px;\n}\n\n.content-wrapper {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 0 0px 0px 0px;\n  /* padding: 0 20px 60px 20px; */\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .hero-image-container {\n    height: 100%;\n    border-radius: 15px;\n  }\n  \n  .hero-section {\n    padding: 10px;\n  }\n}\n/* MOBILE */\n@media (max-width: 480px) {\n  .hero-section {\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n}\n.news-banner {\n  width: 100%;\n  height: 100%;\n  object-fit: cover; /* Asigură că imaginea umple spațiul fără a se deforma */\n  display: block;\n}\n}\n.promovate-section {\n  max-width: 1100px;\n  margin: 40px auto;\n  padding: 0 20px;\n}\n\n.promovate-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.promovate-header h2 {\n  font-size: 24px;\n  font-weight: 800;\n  color: #1a1a1a;\n}\n\n.promovate-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n.promovat-card {\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  position: relative;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.promovat-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);\n}\n\n.promovat-badge {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background: #f4b400;\n  color: #1a1a1a;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  z-index: 2;\n}\n\n.promovat-imagine {\n  position: relative;\n}\n\n.promovat-imagine img {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n}\n\n.promovat-no-img {\n  width: 100%;\n  height: 200px;\n  background: #f9f9f9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 40px;\n}\n\n.promovat-poza-count {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  background: rgba(0,0,0,0.6);\n  color: white;\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.promovat-info {\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.promovat-titlu {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.promovat-titlu strong { font-size: 15px; }\n\n.tip-badge {\n  font-size: 11px;\n  padding: 3px 8px;\n  border-radius: 20px;\n  font-weight: 600;\n}\n.tip-badge.gasit { background: #dcfce7; color: #16a34a; }\n.tip-badge.pierdut { background: #fee2e2; color: #dc2626; }\n\n.promovat-detalii {\n  display: flex;\n  gap: 10px;\n  font-size: 13px;\n  color: #666;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.promovat-contact {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 4px;\n}\n\n.promovat-contact a {\n  font-size: 15px;\n  color: #000000;\n  text-decoration: none;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.promovat-contact a:hover { opacity: 0.8; }\n\n/* Modal — refolosește clasele din AnimaleGasite.css */\n/* Dacă nu ai importul, adaugă aici: */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 20px;\n  animation: fadeIn 0.2s ease;\n}\n\n.modal-anunt {\n  background: white;\n  border-radius: 20px;\n  max-width: 900px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  position: relative;\n  animation: slideUp 0.25s ease;\n}\n\n/* Mobile */\n@media (max-width: 768px) {\n  .promovate-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n  .promovat-imagine img { height: 150px; }\n  .promovate-header h2 { font-size: 20px; }\n}\n\n@media (max-width: 480px) {\n  .promovate-grid {\n    grid-template-columns: 1fr;\n  }\n  .modal-anunt {\n    grid-template-columns: 1fr;\n  }\n}\n\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\n@keyframes slideUp {\n  from { transform: translateY(30px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
